// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uvO_NevOOCAiwZq7HC1N{justify-content:flex-end;gap:8px;width:100%;display:flex}.WXQvwcM0IUE2QxEvj3g1{margin-right:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `uvO_NevOOCAiwZq7HC1N`,
	"deleteAction": `WXQvwcM0IUE2QxEvj3g1`
};
export default ___CSS_LOADER_EXPORT___;
